import { NavLink, useLocation } from 'react-router-dom';

const tabs = [
  { to: '/', label: 'Home', icon: '🏠', end: true },
  { to: '/journal', label: 'Journal', icon: '🎣', end: false },
  { to: '/conditions', label: 'Conditions', icon: '🌤️', end: false },
  { to: '/explore', label: 'Explore', icon: '🔎', end: false },
  { to: '/spots', label: 'Spots', icon: '📍', end: false },
  { to: '/community', label: 'Community', icon: '💬', end: false },
];

export function TabBar() {
  // Hidden on the landing page: somebody who has not started yet has
  // nothing to move between, and the bar makes the page look like a
  // half-loaded app.
  const { pathname } = useLocation();
  if (pathname === '/welcome') return null;

  return (
    <nav className="tabbar" aria-label="Primary">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) => (isActive ? 'tab tab-on' : 'tab')}
        >
          <span aria-hidden="true">{tab.icon}</span>
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
